import { BaseLayout } from '@app/components/common/BaseLayout/BaseLayout';
import { LAYOUT } from '@app/styles/themes/constants';
import { media } from '@app/styles/themes/constants';
import styled, { css } from 'styled-components';

const SAFE_TOP = 'env(safe-area-inset-top, 0px)';

interface Header {
  $isTwoColumnsLayoutHeader: boolean;
}

export const Header = styled(BaseLayout.Header)<Header>`
  line-height: 1.5;
  position: sticky;
  top: 0;
  z-index: 100;
  background: #ffffff;
  border-bottom: 1px solid #eef6f5;
  box-shadow: 0 1px 8px rgba(0, 76, 76, 0.04);
  width: 100%;
  /* Header chứa cả breadcrumb (có thể wrap nhiều dòng trên mobile) — phải tự
     giãn thay vì giữ chiều cao cố định của AntD rồi tràn đè lên nội dung. */
  height: auto;
  min-height: ${LAYOUT.mobile.headerHeight};
  /* PWA iOS (viewport-fit=cover + status bar black-translucent): nội dung vẽ tràn dưới
     status bar/tai thỏ — chừa vùng an toàn phía trên. Trình duyệt thường inset = 0. */
  padding-top: ${SAFE_TOP};

  @media only screen and ${media.md} {
    padding: 0;
    padding-top: ${SAFE_TOP};
    height: auto;
  }

  @media only screen and ${media.md} {
    ${(props) =>
      props?.$isTwoColumnsLayoutHeader &&
      css`
        padding: 0;
        padding-top: ${SAFE_TOP};
      `}
  }
`;
